import $ from "jquery";
import avalon from "avalon";
import ajax from "ajax";
import pagination from "pagination";

var vmodel = avalon.define({
    $id: "searchController",

    consultPagination: pagination.init(0, 0, 0),
    consultGoPage: function(page) {
        if (page.disable) {
            return;
        }
        ajax.pjax(window.server.loadUrl + "&page=" + page.target);
    },
    jump: function(url) {
        ajax.pjax(url);
    }
});

export default {
    init: function() {
        var page = window.server.page;
        vmodel.consultPagination = pagination.init(
            page.total_count,
            page.page,
            page.page_size
        );
        $(".lazy-background").lazyload({
            effect: "fadeIn",
            placeholder:
                window.server.cdnHost + "/dest/quanzi/images/default200.jpg",
            threshold: 300
        });
    },
    clear: function() {}
};
